<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.purchaseStatus === 'N'
              ? 'primary'
              : row.purchaseStatus === 'D'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_purchaseStatus }}
        </el-tag>
      </template>
      <template v-slot:displayCreateByName="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:displayModifyByName="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template> 
      <template v-slot:opt="{ row }">
        <div class="opt-wrapper">
          <!-- 查看详情：文字可点击，带悬停效果 -->
          <span
            class="view-detail-link"
            @click="
              $emit('openEditPage', {
                pageType: 'detail',
                params: { code: row.purchaseFabricCode },
                query: { purchaseFabricNo: row.purchaseFabricNo },
              })
            "
          >
            {{ $l("INDEX.btn_tips_view_V2") || "查看详情" }}
          </span>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l("INDEX.tips_no_data") || "暂无数据！" }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height";
import tableColumns from "./table-columns";

export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    };
  },
  methods: {},
};
</script>
<style scoped>
.opt-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 查看详情的样式：灰色背景 + 圆角 + 内边距 */
.view-detail-link {
  display: inline-block;
  background-color: #f5f7fa;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.view-detail-link:hover {
  background-color: #e6f0ff;
  color: #66b1ff;
  text-decoration: none;
}
</style>